/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gradient[_ngcontent-%COMP%]{width:250px;height:40px;border:0;font-size:15px;font-weight:600;border-radius:25px;color:#f9f9f9;background:linear-gradient(336.68deg,#ff720a 0,#f6c358 100%)}.gradient[_ngcontent-%COMP%]:hover{cursor:pointer}label[_ngcontent-%COMP%]{margin-bottom:0;font-weight:400}label[_ngcontent-%COMP%]:hover{cursor:pointer}"];
export { styles as styles };
